import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { LanguagePageComponent } from '../pages/cms/language/language-page.component';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';

@Injectable({
  providedIn: 'root',
})
export class LanguageFormChangedGuard
  extends FormChangedGuard
  implements CanDeactivate<LanguagePageComponent>
{
  canDeactivate(
    component: LanguagePageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handleNavigation(
      component.hasUnsavedChanges(component.languageForm),
      nextState.url,
      () => component.resetFormChanges,
      () => component.save()
    );
  }
}
